module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwAQMAAABtzGvEAAAABlBMVEUAAAAAAAClZ7nPAAAAAXRSTlMAQObYZgAAABpJREFUeAFjoBZgPkB1yv7//z9YKVrYRyUAAGoSHy2hvqxVAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/components/Attributeview/baseline_add_black_24dp.png
// module id = 135
// module chunks = 0